import api from './index';
import request from '@/utils/request';

export function login(data) {
  return request({
    url: api.Login,
    method: 'post',
    data,
    showloading: true,
  });
}
export function resetPwd(data) {
  return request({
    url: api.ResetPwd,
    method: 'post',
    data,
    showloading: true,
  });
}

export function logout(data) {
  return request({
    url: api.LogOut,
    method: 'post',
    data,
  });
}

export function getUserInfo(data) {
  return request({
    url: api.UserInfo,
    method: 'post',
    data,
  });
}

export function getUserName(params) {
  return request({
    url: api.UserName,
    method: 'get',
    params,
  });
}

export function updatePassword(data) {
  return request({
    url: api.UpdatePassword,
    method: 'post',
    data,
    showloading: true,
  });
}

export function updateUserInfo(data) {
  return request({
    url: api.UserEdit,
    method: 'post',
    data,
  });
}

export function pageQuery(data) {
  return request({
    url: api.PageQuery,
    method: 'post',
    data,
    showloading: true,
  });
}

export function dealerQueryAll(data) {
  return request({
    url: api.DealerQueryAll,
    method: 'post',
    data,
  });
}

export function createUser(data) {
  return request({
    url: api.CreateUser,
    method: 'post',
    data,
    showloading: true,
  });
}

export function deleteUser(data) {
  return request({
    url: api.DeleteUser,
    method: 'post',
    data,
    showloading: true,
  });
}

export function softDelete(data) {
  return request({
    url: api.SoftDelete,
    method: 'post',
    data,
    showloading: true,
  });
}

export function queryRecycle(data) {
  return request({
    url: api.Recycle,
    method: 'post',
    data,
  });
}

export function rserRestore(data) {
  return request({
    url: api.UserRestore,
    method: 'post',
    data,
  });
}

export function userDetail(data) {
  return request({
    url: api.UserDetail,
    method: 'post',
    data,
  });
}

export function dealerPageQuery(data) {
  return request({
    url: api.DealerPageQuery,
    method: 'post',
    data,
  });
}

export function createDealer(data) {
  return request({
    url: api.CreateDealer,
    method: 'post',
    data,
    showloading: true,
  });
}

export function regiser(data) {
  return request({
    url: api.Regiser,
    method: 'post',
    data,
    showloading: true,
  });
}

export function distributionCapacity(data) {
  return request({
    url: api.DistributionCapacity,
    method: 'post',
    data,
  });
}

export function setCapacity(data) {
  return request({
    url: api.SetCapacity,
    method: 'post',
    data,
  });
}

export function setPoint(data) {
  return request({
    url: api.SetPoint,
    method: 'post',
    data,
  });
}

export function changeAuthority(data) {
  return request({
    url: api.ChangeAuthority,
    method: 'post',
    data,
  });
}
export function recommend(data) {
  return request({
    url: api.Recommend,
    method: 'post',
    data,
  });
}
export function queryUserRecommend(data) {
  return request({
    url: api.QueryUserRecommend,
    method: 'post',
    data,
  });
}

export function resetPassword(data) {
  return request({
    url: api.resetPassword,
    method: 'post',
    data,
  });
}

export function checkHbhousing(data) {
  return request({
    url: api.CheckHbhousing,
    method: 'post',
    data,
  });
}

export function clearNotice(data) {
  return request({
    url: api.clearNotice,
    method: 'post',
    data,
  });
}
export function addUserLoginHistory(data) {
  return request({
    url: api.addUserLoginHistory,
    method: 'post',
    data,
  });
}
